import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#1199FA"
        fillRule="evenodd"
        d="M5.778 10.023c-.548 0-1.028.466-1.028 1.068v9.09c0 .603.48 1.069 1.028 1.069h12.444c.548 0 1.028-.466 1.028-1.068V11.09c0-.602-.48-1.068-1.028-1.068H5.778zM3.25 11.09c0-1.398 1.12-2.568 2.528-2.568h12.444c1.408 0 2.528 1.17 2.528 2.568v9.09c0 1.399-1.12 2.569-2.528 2.569H5.778c-1.408 0-2.528-1.17-2.528-2.568V11.09zM12 2.75c-2.059 0-3.694 1.648-3.694 3.795a.75.75 0 11-1.5 0C6.806 3.602 9.08 1.25 12 1.25s5.195 2.352 5.195 5.295a.75.75 0 01-1.5 0c0-2.147-1.636-3.795-3.695-3.795z"
        clipRule="evenodd"
      />
      <path
        fill="#1199FA"
        fillRule="evenodd"
        d="M16.444 5.795a.75.75 0 01.75.75V8.91a.75.75 0 01-1.5 0V6.545a.75.75 0 01.75-.75zM7.556 5.795a.75.75 0 01.75.75v2.637a.75.75 0 11-1.5 0V6.545a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default Icon
